import * as pdfjsLib from 'pdfjs-dist';
import mammoth from 'mammoth';

// Set up PDF.js worker using a CDN to ensure compatibility with standard Create React App setups
// This avoids complex Webpack 5 configuration changes
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

/**
 * Extracts text content from various file types (.txt, .md, .pdf, .docx)
 * @param {File} file - The file object to parse
 * @returns {Promise<string>} - The extracted text
 */
export const extractTextFromFile = async (file) => {
    const extension = file.name.split('.').pop().toLowerCase();

    try {
        switch (extension) {
            case 'txt':
            case 'md':
            case 'json':
                return await readTextFile(file);
            case 'pdf':
                return await readPdfFile(file);
            case 'docx':
                return await readDocxFile(file);
            default:
                throw new Error(`Unsupported file type: .${extension}. Please use PDF, DOCX, or TXT.`);
        }
    } catch (error) {
        console.error("Text extraction failed:", error);
        throw new Error(error.message || "Failed to read file");
    }
};

const readTextFile = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
    });
};

const readPdfFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;

    let fullText = '';

    // Iterate through all pages
    for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map(item => item.str).join(' ');
        fullText += pageText + '\n';
    }

    return fullText.trim();
};

const readDocxFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const result = await mammoth.extractRawText({ arrayBuffer });
    return result.value.trim();
};
